<template>
  <div>
    <div class="error-wrapper-500">
      <div class="content">
        <img class="img" src="@/assets/images/error/error-500.svg" />
        <div class="message">
          <!-- <span class="err-code">500</span> -->
          <div class="msg">{{msg}}</div>
          <div class="back-to-home" @click="toHome">
            返回首页
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'error500',
  data() {
    return {
      type: '',
      msg: this.$route.query.msg
    }
  },
  watch: {},
  created() {},
  methods: {
    toHome() {
      this.$router.push('/index')
    }
  }
}
</script>
<style lang="less">
.error-wrapper-500 {
  .content {
    margin: 5% auto;
    width: 840px;
    display: table;
    .img {
      vertical-align: middle;
      margin-right: 92px;
    }
    .message {
      display: table-cell;
      vertical-align: middle;
    }
    .err-code {
      font-size: 120px;
      line-height: 138px;
      color: #666;
    }
    .msg {
      font-size: 32px;
      line-height: 38px;
      color: #636363;
      margin-bottom: 24px;
    }
    .back-to-home {
      width: 210px;
      height: 52px;
      line-height: 50px;
      font-size: 18px;
      color: #fff;
      background: #f85415;
      text-align: center;
      border-radius: 20px;
      border: 1px solid #f85415;
      cursor: pointer;
      display: inline-block;
      &:hover {
        background: #e64507;
        -webkit-box-shadow: 0 0 10px 0 rgba(255, 103, 26, 0.3),
          0 5px 10px 0 rgba(255, 103, 26, 0.6);
        box-shadow: 0 0 10px 0 rgba(255, 103, 26, 0.3),
          0 5px 10px 0 rgba(255, 103, 26, 0.6);
        color: #fff;
      }
    }
  }
}
</style>